// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-2199837f]{display:block;color:#7a7f89;font-size:12px;font-weight:500;margin-bottom:10px}.description[data-v-2199837f]:last-child{margin-bottom:0}.description .click-here[data-v-2199837f]{font-weight:700}.description .click-here[data-v-2199837f]:hover{color:#2680eb;cursor:pointer}.error-message[data-v-2199837f]{margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
